import { render, staticRenderFns } from "./ProfileDashboard.vue?vue&type=template&id=49f22eab&scoped=true&"
import script from "./ProfileDashboard.vue?vue&type=script&lang=js&"
export * from "./ProfileDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDashboard.vue?vue&type=style&index=0&id=49f22eab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f22eab",
  null
  
)

export default component.exports